var React = require('react');

function GuarantorArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Arrow","transform":"translate(1.414 1.414)"},React.createElement("path",{"id":"Arrow-2","data-name":"Arrow","d":"M24,0,12,12,0,0","transform":"translate(0 24) rotate(-90)","fill":"none","stroke":"#253746","strokeMiterlimit":"10","strokeWidth":"4","opacity":"0.9"})));
}

GuarantorArrowRight.defaultProps = {"width":"16.243","height":"26.829","viewBox":"0 0 16.243 26.829"};

module.exports = GuarantorArrowRight;

GuarantorArrowRight.default = GuarantorArrowRight;
